import * as api from 'syft-acp-core/api/resources/admin/workers'
import { takeLatestApiCall } from './helpers'

export default function* root() {
  yield takeLatestApiCall('WORKER_UPCOMING_JOBS_FETCH', api.fetchUpcomingWorkerJobs)
}
